import Form from 'components/Form';
import {
  Box,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
} from '@mui/material';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const contentLabel = [
  {
    id: 1,
    ko: '얼굴',
    desc: '눈썹 찌푸림, 찡그린 얼굴, 경련, 꽉 물은 턱, 경직된 얼굴',
    keyName: 'face_algo',
  },
  {
    id: 2,
    ko: '시선',
    desc: '무관심한 눈빛,  고정된 시선, 먼산을 바라보거나 애원하는 눈빛, 눈물, 눈 감음',
    keyName: 'sight_algo',
  },
  {
    id: 3,
    ko: '신음소리',
    desc: '“아야”, “아우”, “아파요”, 신음, 비명',
    keyName: 'shout_algo',
  },
  {
    id: 4,
    ko: '신체',
    desc: '어느 부위를 뒤로 빼거나 보호하는 자세, 움직임 거부, 경직된 자세',
    keyName: 'body_algo',
  },
  {
    id: 5,
    ko: '행동',
    desc: '흥분 또는 공격성, 움켜잡음',
    keyName: 'action_algo',
  },
  {
    id: 6,
    ko: '총점',
    desc: '',
    keyName: '',
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}
const Algoplus = (props: Props) => {
  const { disabled, setValue, getValues, register } = props;

  const 얼굴Algo01 = props.watch('face_algo01')
    ? Number(props.watch('face_algo01'))
    : 0;
  const 시선01 = props.watch('sight_algo01')
    ? Number(props.watch('sight_algo01'))
    : 0;
  const 신음01 = props.watch('shout_algo01')
    ? Number(props.watch('shout_algo01'))
    : 0;
  const 신체Algo01 = props.watch('body_algo01')
    ? Number(props.watch('body_algo01'))
    : 0;
  const 행동01 = props.watch('action_algo01')
    ? Number(props.watch('action_algo01'))
    : 0;

  const 얼굴Algo02 = props.watch('face_algo02')
    ? Number(props.watch('face_algo02'))
    : 0;
  const 시선02 = props.watch('sight_algo02')
    ? Number(props.watch('sight_algo02'))
    : 0;
  const 신음02 = props.watch('shout_algo02')
    ? Number(props.watch('shout_algo02'))
    : 0;
  const 신체Algo02 = props.watch('body_algo02')
    ? Number(props.watch('body_algo02'))
    : 0;
  const 행동02 = props.watch('action_algo02')
    ? Number(props.watch('action_algo02'))
    : 0;

  const 얼굴Algo03 = props.watch('face_algo03')
    ? Number(props.watch('face_algo03'))
    : 0;
  const 시선03 = props.watch('sight_algo03')
    ? Number(props.watch('sight_algo03'))
    : 0;
  const 신음03 = props.watch('shout_algo03')
    ? Number(props.watch('shout_algo03'))
    : 0;
  const 신체Algo03 = props.watch('body_algo03')
    ? Number(props.watch('body_algo03'))
    : 0;
  const 행동03 = props.watch('action_algo03')
    ? Number(props.watch('action_algo03'))
    : 0;

  const 총점1 = 얼굴Algo01 + 시선01 + 신음01 + 신체Algo01 + 행동01;

  const 총점2 = 얼굴Algo02 + 시선02 + 신음02 + 신체Algo02 + 행동02;

  const 총점3 = 얼굴Algo03 + 시선03 + 신음03 + 신체Algo03 + 행동03;

  return (
    <>
      <SectionTitle title="Algoplus" mt={3} mb={2} />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer>
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              >
                예: 1점, 아니오: 0점 입력하세요.
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  paddingLeft: '30px',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실
                <br />
                5분이내
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실
                <br />
                5분이후
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실 or
                <br />
                중재
                <br />
                30분후
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>

          <TableBody>
            {contentLabel.map(
              (
                content: {
                  id: number;
                  ko: string;
                  desc: string;
                  keyName: string;
                },
                i
              ) => {
                if (content.ko === '총점') {
                  return (
                    <TableRow>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          padding: '16px',
                          width: '150px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.ko}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc}
                      </StyledTableCellTwo>

                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px', marginLeft: '30px' }}
                          value={총점1}
                        />
                      </StyledTableCellWithoutLeftTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px', margin: '0 30px 0 30px' }}
                          value={총점2}
                        />
                      </StyledTableCellWithoutLeftTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px' }}
                          value={총점3}
                        />
                      </StyledTableCellWithoutLeftTwo>
                    </TableRow>
                  );
                }

                return (
                  <TableRow>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        padding: '16px',
                        width: '150px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.ko}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '1000px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc}
                    </StyledTableCellTwo>

                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px', marginLeft: '30px' }}
                        type="number"
                        {...register(`${content.keyName}01`, {
                          onChange: e => {
                            if (e.target.value > 1) {
                              alert('0-1까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}01`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}01`, 0);
                            }
                            setValue(
                              `${content.keyName}01`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px', margin: '0 30px 0 30px' }}
                        type="number"
                        {...register(`${content.keyName}02`, {
                          onChange: e => {
                            if (e.target.value > 1) {
                              alert('0-1까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}02`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}02`, 0);
                            }
                            setValue(
                              `${content.keyName}02`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px' }}
                        type="number"
                        {...register(`${content.keyName}03`, {
                          onChange: e => {
                            if (e.target.value > 1) {
                              alert('0-1까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}03`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}03`, 0);
                            }
                            setValue(
                              `${content.keyName}03`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default Algoplus;
